import axios from "axios";

export default axios.create({
  baseURL: "https://retoolapi.dev/rwuvkK/new_user",
  // baseURL: "http://localhost:3001/admin",
  headers: {
    "Content-type": "application/json"
  }
});
